import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'paginator',
  templateUrl: './paginator.component.html',
  styles: [`
    .mat-paginator {
      display: inline-block !important;
      margin: 0 !important;
      float: left;
    }
    .mat-paginator-container {
      min-height: 0 !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class PaginatorComponent {

  @Input() length = 0;
  @Input() pageSize = 0;
  @Input() pageSizeOptions = [5, 10, 20];
  @Input() disabled = false;

  @Output() page = new EventEmitter<PageEvent>();

}
